import {Injectable} from '@angular/core';
import {User} from '@drl/core/auth/models/user.model';
import {RoleType} from '@drl/core/enums';
import {roleTypes, UserType} from '../utility/netcore-events.enum';
// sonarignore:start
declare var smartech: any;
// sonarignore:end
@Injectable({
  providedIn: 'root',
})
export class SmartechService {
  private readonly roleTypesAllowed = [
    RoleType.Admin,
    RoleType.Doctor,
    RoleType.Nurse,
    RoleType.Nutritionist,
    RoleType.Psychologist,
    RoleType.Specialist,
  ];

  /**
   * To generate CEE events
   * @param user , pass user
   * @param eventName , pass eventName
   */
  pageLoadEvents(user: User, eventName: string) {
    if (this.roleTypesAllowed.includes(Number(user.role))) {
      // get user login detail that is new/existing
      const loginUser =
        user.lastLogin !== null ? UserType.existingUser : UserType.newUser;
      // identify user and dispatch event
      smartech('contact', 'LIST IDENTIFIER', {
        'pk^customerid': user.id
        });
      smartech('identify', user.id);
      smartech('dispatch', eventName, {
        count: loginUser,
        userType: roleTypes[Number(user.role)],
      });
    }
  }
}
